import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url } from "../../utils/utils";

export const add_banner = createAsyncThunk(
  "banner/add_banner",
  async (info, { fulfillWithValue, rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `${api_url}/api/hospital-banner/add`,
        info,
        config,
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Server Error" },
      );
    }
  },
);

export const update_banner = createAsyncThunk(
  "banner/update_banner",
  async ({ id, info }, { fulfillWithValue, rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.put(
        `${api_url}/api/hospital-banner/update/${id}`,
        info,
        config,
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Update failed" },
      );
    }
  },
);
export const get_banner = createAsyncThunk(
  "banner/get_banner",
  async (
    { id, hospital_id },
    { fulfillWithValue, rejectWithValue, getState },
  ) => {
    try {
      const token = getState().auth.token;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${api_url}/api/hospital-banner/get/${id}?hospital_id=${hospital_id}`,
        config,
      );
      console.log(data,"data")
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Error fetching banner" },
      );
    }
  },
);

export const delete_banner = createAsyncThunk(
  "banner/delete_banner",
  async (
    { id, hospital_id },
    { fulfillWithValue, rejectWithValue, getState },
  ) => {
    console.log(id, hospital_id)
    try {
      const token = getState().auth.token;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          hospital_id,
        },
      };

      const { data } = await axios.delete(
        `${api_url}/api/hospital-banner/delete/${id}`,
        config,
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Delete failed" },
      );
    }
  },
);



export const get_banners = createAsyncThunk(
  "banner/get_banners",
  async (
    { hospital_id, page, parPage, searchValue },
    { fulfillWithValue, rejectWithValue, getState }
  ) => {
    try {
      const token = getState().auth.token;

      const { data } = await axios.get(
        `${api_url}/api/hospital-banner/get-banners/${hospital_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            parPage,
            searchValue,
          },
        }
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    banners: [],
    banner: null,
    totalBanner: 0,
  },

  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder

      // ADD
      .addCase(add_banner.pending, (state) => {
        state.loader = true;
      })
      .addCase(add_banner.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.banner = payload.banner;
      })
      .addCase(add_banner.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload?.message;
      })

      // GET ALL
      .addCase(get_banners.fulfilled, (state, { payload }) => {
        state.banners = payload.hospitalbanners;
        state.totalBanner = payload.totalBanner;
      })

      // GET ONE
      .addCase(get_banner.pending, (state) => {
        state.loader = true;
      })
      .addCase(get_banner.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.banner = payload.hospitalbanner;
      })
      .addCase(get_banner.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.message || "Network Error";
      })

      // UPDATE
      .addCase(update_banner.pending, (state) => {
        state.loader = true;
      })
      .addCase(update_banner.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.banner = payload.banner;
      })
      .addCase(update_banner.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.message || "Network Error";
      })

      // DELETE
      .addCase(delete_banner.pending, (state) => {
        state.loader = true;
      })
      .addCase(delete_banner.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
      })
      .addCase(delete_banner.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.message || "Network Error";
      });
  },
});

export const { messageClear } = bannerSlice.actions;
export default bannerSlice.reducer;


// export const { messageClear } = bannerReducer.actions;
// export default bannerReducer.reducer;
